var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExtranjeros = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "79px",
    viewBox: "0 0 79 79",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 12")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-5",
    transform: "translate(-1154.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1154.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    fill: "#A489D4",
    opacity: 0.645693824,
    cx: 39.5,
    cy: 39.5,
    r: 39.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,19 C28.408,19 19,28.408 19,40 C19,51.592 28.408,61 40,61 C51.592,61 61,51.592 61,40 C61,28.408 51.592,19 40,19 Z M38.6,56.8 C30.7,55.741358 24.6,48.4820988 24.6,39.667284 C24.6,38.3277778 24.76,37.0530864 25.02,35.8 L34.6,46.1487654 L34.6,48.3092593 C34.6,50.6858025 36.4,52.6302469 38.6,52.6302469 L38.6,56.8 Z M52.39,51.2 C51.844,49.428125 50.29,48.159375 48.4,48.159375 L46.3,48.159375 L46.3,41.596875 C46.3,40.39375 45.355,39.409375 44.2,39.409375 L31.6,39.409375 L31.6,35.034375 L35.8,35.034375 C36.955,35.034375 37.9,34.05 37.9,32.846875 L37.9,28.471875 L42.1,28.471875 C44.41,28.471875 46.3,26.503125 46.3,24.096875 L46.3,23.2 C52.453,25.803125 56.8,32.08125 56.8,39.409375 C56.8,43.959375 55.12,48.09375 52.39,51.2 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExtranjeros, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/extranjeros.ecc7fc75.svg";
export { ForwardRef as ReactComponent };